// CMS.jsx
import cls from "./CMS.module.scss";
import { Link } from "react-router-dom";
import PortalIconMini from "@/components/icons/PortalIconMini";
import LanguageIconKinkyMini from "@/components/icons/LanguageIconKinkyMini";
export default function CMS() {
  return (
    <div className={cls.page}>
      <header className={cls.header}>
        <div>
          <h1 className="nu-title" data-glow="1">
            Pages Hub
          </h1>
          <p className={cls.sub}>
            Manage seasonal titles, subtitles, and hero images.
          </p>
        </div>
      </header>

      <section className={cls.grid}>
        <Link to="/admin/home-cms" className={`${cls.tile} nu-btn is-mrs`}>
          <span className={cls.tileIcon}>
            <PortalIconMini size={22} />
          </span>
          <span className={cls.tileTitle}>Home Page</span>
          <span className={`${cls.tilePill} ${cls["tilePill--success"]}`}>
            Published
          </span>
        </Link>
        <Link to="/admin/language-cms" className={`${cls.tile} nu-btn is-mr`}>
          <span className={cls.tileIcon}>
            <LanguageIconKinkyMini size={22} />
          </span>
          <span className={cls.tileTitle}>Language Page</span>
          <span className={`${cls.tilePill} ${cls["tilePill--success"]}`}>
            Published
          </span>
        </Link>
        <Link to="/admin/admin-welcome" className={`${cls.tile} nu-btn is-mrs`}>
          <span className={cls.tileIcon}>
            <PortalIconMini size={22} />
          </span>
          <span className={cls.tileTitle}>Welcome</span>
          <span className={`${cls.tilePill} ${cls["tilePill--success"]}`}>
            Published
          </span>
        </Link>
      </section>
    </div>
  );
}
